import * as React from "react";
import { useState } from "react";
import logo from "../../assets/spero_logo_new.png";
import "./Login.css";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import InputBase from "@mui/material/InputBase";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import useMediaQuery from "@mui/material/useMediaQuery";
import user from "../../assets/user.png";
import key from "../../assets/key.png";
import { useAuth } from "../Context/ContextAPI";
import { port } from "../../../../src/config";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { API_URL } from "../Config/api";

export default function Login() {
  const { handleAuth } = useAuth();
  // const port = process.env.REACT_APP_API_KEY;
  const [login, setLogin] = useState({ clg_ref_id: "", password: "" });
  const [userIdError, setUserIdError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showExistErrorAlert, setShowExistErrorAlert] = useState(false);
  const [showExistErrorAlert1, setShowExistErrorAlert1] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const navigate = useNavigate();

  const handleChange = async (e) => {
    e.preventDefault();

    setUserIdError(login.clg_ref_id === "");
    setPasswordError(login.password === "");

    if (login.clg_ref_id === "" || login.password === "") {
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/web/login/`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          clg_ref_id: login.clg_ref_id,
          password: login.password,
        }),
      });
      if (response.status === 401) {
        console.log("Resource not found.");
        setShowExistErrorAlert1(true);
        setTimeout(() => setShowExistErrorAlert1(false), 3000);
      }
      if (response.status === 404) {
        console.log("Resource not found.");
        setShowErrorAlert(true);
        setTimeout(() => setShowErrorAlert(false), 3000);
      } else {
        setShowErrorAlert(false);
        const data = await response.json();
        if (data.msg === "User Already Logged In. Please check.") {
          setShowExistErrorAlert(true);
          setTimeout(() => setShowExistErrorAlert(false), 3000);
        } else {
          setSuccessAlert(true);
          console.log("Login Credentials.....", data);
          localStorage.setItem("token", data.token.access);
          localStorage.setItem("refresh", data.token.refresh);
          localStorage.setItem(
            "user-image",
            data.token.colleague.profile_photo_path
          );
          localStorage.setItem("user-name", data.token.colleague.first_name);
          localStorage.setItem("user-lname", data.token.colleague.last_name);
          localStorage.setItem("user-email", data.token.colleague.email);
          localStorage.setItem("user-phone", data.token.colleague.phone_no);
          localStorage.setItem("user-loc", data.token.colleague.address);
          localStorage.setItem(
            "user-designation",
            data.token.colleague.designation
          );
          localStorage.setItem("clg_id", data.token.colleague.id);
          localStorage.setItem("hospitalId", data.token.colleague.clg_hosp_id);
          localStorage.setItem("clgrefId", data.token.colleague.clg_ref_id);
          localStorage.setItem("user_group", data.token.user_group);
          localStorage.setItem(
            "permissions",
            JSON.stringify(data.token.permissions)
          );
          localStorage.setItem("companyID", data.token.colleague.prof_compny);
          setTimeout(() => {
            if (data.token.user_group === "hd") {
              navigate("/dashboard");
              handleAuth();
              window.location.reload();
            } else if (data.token.user_group === "HR") {
              navigate("/hr/manage profiles");
            } else if (data.token.user_group === "M_DASH") {
              navigate("/MM2Dashboard");
            } else if (data.token.user_group === "HR Partner") {
              navigate("/hr partner/manage professionals");
            } else if (data.token.user_group === "ADMIN") {
              navigate("/hhc/dashboard");
            } else if (data.token.user_group === "ACCOUNT") {
              navigate("/hhc/account/dashboard");
            } else if (data.token.user_group === "REPORTS") {
              navigate("/reports/dashboard");
            } else if (data.token.user_group === "HOSPITAL") {
              navigate("/hospital/dashboard");
            } else if (data.token.user_group === "ATTENDANCE") {
              navigate("/attendance/attendance-view");
            } else if (data.token.user_group === "MANAGEMENT") {
              navigate("/management/management-dashboard");
            }
            // else if (data.token.user_group === "clincal_gov") {
            //     navigate("/hhc/clinical");
            // }
            else if (data.token.user_group === "clincal_gov") {
              // navigate("/hhc/clinical");
              navigate("/hhc/clinical/closure");
            } else if (data.token.user_group === "HHC_Analytics") {
              navigate("/analytics/home");
            } else if (data.token.user_group === "physio") {
              navigate("/physio");
            } else if (data.token.user_group === "physioMilestone") {
              navigate("/physioMilestone");
            }
            else if (data.token.user_group === "Consultant") {
              navigate("/hhc/consultant/referred patient details");
            }
          }, 2000);

        }

      }
    } catch (error) {
      console.error("Error during API call:", error);
    } finally {
      setLoading(false);
    }
  };

  const onchange = (e) => {
    const { name, value } = e.target;
    setLogin((prevLogin) => ({
      ...prevLogin,
      [name]: value,
    }));
    if (name === "clg_ref_id") {
      setUserIdError(false);
    } else if (name === "password") {
      setPasswordError(false);
    }
  };

  return (
    <>
      <div className="container">
        <div className="input_fields">
          {isSmallScreen ? null : (
            <img
              src={logo}
              alt=""
              style={{
                height: "110px",
                width: "160px",
                // boxShadow: "0 4px 8px rgba(0,0,0,0.3)", 
                borderRadius: "8px" // optional: thoda curve look ke liye
              }}
            />
          )}
          {successAlert && (
            <Alert severity="success" variant="filled">
              Login Successful! Redirecting...
            </Alert>
          )}
          {/* <Typography variant='h6' sx={{ m: 2 }}>HD LOGIN</Typography> */}
          {showErrorAlert && (
            <Alert severity="error" variant="filled">
              Invalid User ID or Password!
            </Alert>
          )}
          {showExistErrorAlert && (
            <Alert severity="error" variant="filled">
              User is already logged in!
            </Alert>
          )}
          {showExistErrorAlert1 && (
            <Alert severity="error" variant="filled">
              Login Access Denied!
            </Alert>
          )}
          <Box
            component="form"
            sx={{
              mt: 5,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "6px",
              border: "1px solid #000",
            }}
          >
            <img
              src={user}
              alt=""
              style={{ height: "18px", marginLeft: "8px" }}
            />
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Enter User ID"
              name="clg_ref_id"
              autoComplete="off"
              onChange={onchange}
              required
              error={userIdError}
              helperText={userIdError && "User ID is required"}
            />
          </Box>

          {userIdError && (
            <Typography variant="body2" color="error" textAlign="left">
              User ID is required*
            </Typography>
          )}

          <Box
            component="form"
            sx={{
              mt: 3,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "6px",
              border: "1px solid #000",
            }}
          >
            <img
              src={key}
              alt=""
              style={{ height: "20px", marginLeft: "8px" }}
            />
            <InputBase
              sx={{ ml: 1.2, flex: 1 }}
              placeholder="Enter Password"
              type={showPassword ? "text" : "password"}
              name="password"

              onChange={onchange}
              required
              error={passwordError}
              helperText={passwordError && "Password is required"}
            />
            <Button
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
              size="small"
              startIcon={showPassword ? <VisibilityOff /> : <Visibility />}
            >
              {/* {showPassword ? "Hide" : "Show"} */}
            </Button>
          </Box>
          {passwordError && (
            <Typography variant="body2" color="error" textAlign="left">
              Password is required*
            </Typography>
          )}

          <Button
            variant="contained"
            sx={{
              mt: 6,
              width: "28ch",
              height: "7vh",
              backgroundColor: "#69DAC3",
              borderRadius: "6px",
              textTransform: "capitalize",
              color: "black",
            }}
            onClick={handleChange}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </Button>
          {isSmallScreen ? (
            <img src={logo} alt="" style={{ height: "70px", width: "120px" }} />
          ) : null}

          <Box
            sx={{
              mt: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            {/* Row 1 */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: { xs: 2, md: 2 },
                flexWrap: "wrap",
              }}
            >
              {[
                { label: "Privacy & Policy", path: "/termsandconditions" },
                { label: "Refund & Cancellation", path: "/CancellationRefundPolicy" },
                { label: "Contact Us", path: "/ContactInfo" },
                { label: "About Us", path: "/About-Us" },
              ].map((item, index) => (
                <Typography
                  key={index}
                  variant="body1"
                  sx={{
                    position: "relative",
                    color: "#444",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      color: "#0072BC",
                      transform: "translateY(-2px)",
                    },
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: -3,
                      left: 0,
                      width: "0%",
                      height: "2px",
                      bgcolor: "#69DAC3",
                      borderRadius: 1,
                      transition: "width 0.3s ease",
                    },
                    "&:hover::after": {
                      width: "100%",
                    },
                  }}
                  onClick={() => navigate(item.path)}
                >
                  {item.label}
                </Typography>
              ))}
            </Box>

            {/* Decorative Divider */}
            <Box
              sx={{
                width: 120,
                height: 3,
                borderRadius: 2,
                background: "linear-gradient(90deg, #69DAC3, #3DDAD7)",
                mt: 2,
              }}
            />
          </Box>

        </div>
      </div>
    </>
  );
}
